import React from "react";
import { getBranchPlan } from "../../../../api/plans";
import { Table } from "react-bootstrap";
import ReloadPlanDataButton from "../../../../_components/ReloadPlanDataButton";
import CardUpgrade from "../CardUpgrade";
import BuyAdditionalNotes from "../BuyAdditionalNotes";
import Text from "../../../../_components/Text";
import Button from "../../../../_components/Button";
import Currency from "react-currency-formatter";
import CancelPlan from "../CancelPlan";
import { formatDate } from "../../../../utils";

import Page from "../../../../_components/Layout/Page";
import Row from "../../../../_components/Layout/Row";
import Column from "../../../../_components/Layout/Column";

import { useAdaptTableData } from "../hooks";

export default (props) => {
  const ref = React.useRef(null);
  const [branchPlan, setBranchPlan] = React.useState({
    status: {},
    showUpgradeButton: true,
    invoices: [],
    additional_notes: {},
  });
  const [setPlanStatus] = useAdaptTableData();
  /*
    Planos Gratuitos+
    Plano Free
    Plano Gestão
    planos Pagos
    Plano Ilimitado
  */
  function goToInvoices() {
    window.location.href = "/plan/branch-invoices";
  }
  function init() {
    getBranchPlan()
      .then((plan) => {
        plan.status_code = plan.status;

        // botão de comprar mais notas
        plan.showUpgradeButton = true;
        plan.disabledBuyAdditionalNotes = false;
        plan.allowBuyAdditionalNotes = true;
        plan.status = setPlanStatus(plan.status);
        let additional_notes = 0;
        plan.total_notes = plan.notes_quantity;
        plan.available_notes = 0;

        if (!plan.additional_notes) {
          plan.additional_notes = {};
        } else {
          additional_notes = plan.additional_notes.quantity;
        }
        plan.total_notes += additional_notes;
        plan.available_notes = plan.total_notes - plan.total_sended_notes;

        if (plan.paid_value > 0) {
          plan.disabledBuyAdditionalNotes = true;
          plan.allowBuyAdditionalNotes = true;
          // <= 0 :O
          if (plan.status_code == 1 && plan.available_notes <= 0) {
            plan.disabledBuyAdditionalNotes = false;
          }
        }
        if (plan.status_code != 1) {
          plan.disabledBuyAdditionalNotes = false;
          plan.showUpgradeButton = true;
        }
        if (!plan.invoices) {
          plan.invoices = [];
        }
        if (plan.plan === "b85046a1-3803-4ee4-a858-8ef2c26d9d76") {
          plan.available_notes = "Ilimitadas";
          plan.notes_quantity = "Ilimitadas";
          plan.showUpgradeButton = false;
        }
        if (plan.plan === "94dc6704-876d-4c5b-80fe-1b7530b72f64") {
        }
        plan.end_date = formatDate(plan.end_date);
        if (plan.available_notes < 0) {
          plan.available_notes = 0;
        }
        setBranchPlan(plan);
      })
      .catch((error) => {
        if (error.data) {
          if (error.data.error) {
            if (error.data.error === "plan_not_found") {
              window.location.href = "/plans/select";
            }
          }
        }
      })
      .finally();
  }
  React.useEffect(init, [ref.current]);
  return (
    <Page ref={ref}>
      <Row>
        <Column col="12">
          <Text fontSize="lg" color="primary">
            Assinatura
          </Text>
        </Column>
      </Row>
      <Row>
        <Column col="12">
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>
                  <Text>Assinatura</Text>
                </th>
                <th>Status</th>
                <th>Próxima cobrança</th>
                <th>Valor</th>
                <th>Notas adquiridas</th>
                <th>Notas disponíveis</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <Text>{branchPlan.plan_name}</Text>
                </td>
                <td>
                  <Text>{branchPlan.status.text}</Text>
                  <div>
                    <ReloadPlanDataButton />
                  </div>
                </td>
                <td>
                  <Text>{branchPlan.end_date}</Text>
                </td>
                <td>
                  <Text>
                    <Currency currency="BRL" quantity={branchPlan.paid_value} />
                  </Text>
                </td>
                <td>
                  <Text>
                    <span className="badge badge-primary">
                      {branchPlan.notes_quantity}{" "}
                    </span>
                    {branchPlan.additional_notes.quantity ? (
                      <span className="badge badge-info ml-2">
                        +{branchPlan.additional_notes.quantity}
                      </span>
                    ) : (
                      ""
                    )}
                  </Text>
                </td>
                <td>
                  <Text>{branchPlan.available_notes}</Text>
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="d-flex ">
            <div className="ml-5">
              
            </div>
            <div></div>
          </div>
        </Column>
      </Row>
      <div className="row">
        <div
          className={`col-md-12 py-2 ${
            branchPlan.invoices.length > 0 ? "bg-warning text-white" : ""
          }`}
        >
          <Text className="lead">
            Faturas
            {branchPlan.invoices.length > 0
              ? ` Você possui ${branchPlan.invoices.length} faturas abertas.`
              : ""}
          </Text>
        </div>
        <div className="col-md-12 py-2">
          <Text className="lead text-dark">
            Clique{" "}
            <Button onClick={goToInvoices} as="text" className="text-info" >
              aqui
            </Button>{" "}
            para acessar todas as faturas.
          </Text>
        </div>
        <div
          className={`${
            branchPlan.additional_notes.quantity ? "col-md-12 py-3" : "d-none"
          }`}
        >
          <Text className="lead">
            Você adquiriu {branchPlan.additional_notes.quantity} notas
            adicionais válidas até {branchPlan.additional_notes.validate_date}
          </Text>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 py-2">
          <CancelPlan />
        </div>
      </div>
    </Page>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/BranchPlan/index.jsx